import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CoreToolbox } from 'src/app/core/utils/core-toolbox';

@Component({
	selector: 'app-home',
	styleUrls: ['./login.scss'],
	templateUrl: './home.html'
})
export class HomeComponent implements OnInit, OnDestroy {
	languageActive: string;

	constructor(private translate: TranslateService) { }

	ngOnDestroy(): void {
	}
	ngOnInit(): void {
		this.languageActive = CoreToolbox.storageService.getItem('language') || 'en';
	}

	useLanguage(lang: string) {
		CoreToolbox.storageService.setItem('language', lang);
		this.languageActive = lang;
		this.translate.use(lang);
	}
}
